"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconNewspaperActive = Experimental__IconNewspaperActive;
exports.IconNewspaperActive = IconNewspaperActive;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconNewspaperActive/index.tsx)
 */
function IconNewspaperActive(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M1.263.691A.75.75 0 0 1 2.01 0h11.24a.75.75 0 0 1 .75.75V2h2.25a.75.75 0 0 1 .75.75v9.685a19.939 19.939 0 0 1-.05 1.402c-.03.38-.08.801-.17 1.143a1.965 1.965 0 0 1-.219.542c-.1.16-.356.478-.811.478H3.087c-.754 0-1.164-.62-1.365-1.061-.225-.493-.375-1.142-.481-1.843C1.027 11.68.962 9.82.966 7.998c.005-1.83.079-3.656.152-5.022A114.939 114.939 0 0 1 1.25.858l.01-.124.003-.043ZM11 5V3.5H4V5h7ZM4 8.75h7v-1.5H4v1.5Zm7 3.75V11H4v1.5h7Zm4.5-.181V3.5H14v8.808c0 .796.13 1.336.368 1.666.166.23.443.438.99.504a6.57 6.57 0 0 0 .096-.758 16.442 16.442 0 0 0 .046-1.374v-.027Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M2.5 1a1 1 0 0 0-.997.925l-.005.06-.012.17-.043.64c-.035.551-.082 1.337-.13 2.28A142.723 142.723 0 0 0 1.126 12c0 2.511.093 5.072.386 7.023.145.966.348 1.855.651 2.528C2.432 22.148 2.98 23 4 23h17.5c1.02 0 1.545-.852 1.78-1.37.267-.596.423-1.329.521-1.982.1-.669.15-1.33.174-1.817a20.9 20.9 0 0 0 .025-.765V6a1 1 0 0 0-1-1h-3V2a1 1 0 0 0-1-1H2.5ZM16 9H5V7h11v2ZM5 13v-2h11v2H5Zm11 4H5v-2h11v2Zm6-10v10.046a18.07 18.07 0 0 1-.177 2.306c-.089.597-.214 1.114-.368 1.456a1.558 1.558 0 0 1-.092.178c-.151-.032-.295-.124-.452-.321-.224-.28-.419-.713-.57-1.249C20.042 18.352 20 17.203 20 17V7h2Zm-.695 14.061.015-.014a.082.082 0 0 1-.015.014Z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconNewspaperActive is deprecated and will be archived soon. Use IconNewspaperActive instead.
 */
function Experimental__IconNewspaperActive(props) {
  return /*#__PURE__*/_react["default"].createElement(IconNewspaperActive, props);
}